import React from 'react';

import FormNumberInput from './FormNumberInput';

import {
  currencyFormatter,
  currencyParser,
} from '../../helpers/inputParsers';

export default ({
  isNotDisplay,
  label,
  name,
  value,
  rules = [],
  min,
  max,
  step = 0.01,
  precision = 2,
  formatter = currencyFormatter,
  parser = currencyParser,
  ...restProps
}) => (
  <FormNumberInput
    isNotDisplay={isNotDisplay}
    label={label}
    name={name}
    value={value}
    rules={rules}
    numberInputProps={{
      formatter,
      parser,
      precision,
      min,
      max,
      step,
    }}
    {...restProps}
  />
);